export const TOKEN_TYPE = 'Bearer '
export const REQUEST_HEADER_AUTH_KEY = 'Authorization'

export enum HttpCodes {
    Unauthorized = 401,
    Network_Error = 'ERR_NETWORK',
}
